<template lang="html">
    <div>
        <!-- Top bar-->
        <department-header/>
        <!-- Begin Page Content -->
        <components v-bind:is="Content" v-on:change-view="goPage" :properties="properties" />
    </div>
</template>

<script>
    import Header from '@/views/Common/Header.vue'
	import List from '@/views/Management/Department/List.vue'
	
    export default {
        name: 'Department',
        components: 
        {
            'department-header': Header,
			'department-content': List,
        },
        created () {
            this.$axios.defaults.headers.common['x-access-token'] = this.$store.getters.getAccessToken;
            this.$axios.defaults.headers.common['x-refresh-token'] = this.$store.getters.getRefreshToken;
        },
        mounted(){
			//화면 새로고침시 기존 화면 불러오기
            if(this.$route.params.mid){
				this.goPage({'mid':this.$route.params.mid, 'type':this.$route.params.type});
			}else{
				this.goPage({'mid':sessionStorage.mid, 'type':sessionStorage.type});
			}
            
        },
        data () {
            return {
                Content: '',
                properties:[],
            }
        },
        methods: {
            goPage(data){
                this.Content = 'department-content';
                this.properties = data;
                sessionStorage.removeItem('type');
                sessionStorage.removeItem('mid');
                sessionStorage.setItem('type', data.type);
                sessionStorage.setItem('mid',data.mid);
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/Management/Department/Department.vue